import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuardService}from'../services/auth-guard.service';
import { ModalDatasetPage } from './modal-dataset.page';

const routes: Routes = [
  {
    path: '',
    component: ModalDatasetPage,
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalDatasetPageRoutingModule {}
